var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-center":"","column":""}},[_c('img',{staticClass:"Hero",attrs:{"src":require("../../assets/HubungiKami/Hero.png"),"srcset":require("../../assets/HubungiKami/Hero@2x.png") + " 2x, " + require("../../assets/HubungiKami/Hero@3x.png") + " 3x"}}),_c('p',{staticClass:"Text-Hero",style:({ marginTop: _vm.marginTopText, width: _vm.textWidth, fontSize: _vm.fontSize })},[_vm._v(" Get In Touch ")]),_c('p',{staticClass:"Desc-Hero",style:({
      marginTop: _vm.marginTopDesc,
      width: _vm.descWidth,
      fontSize: _vm.fontSizeDesc,
    })},[_vm._v(" Tambah Penghasilanmu dengan Cepat, Lakukan Pendanaan di Dompet Kilat ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }